<template>
  <div class="page">
    <div class="div-header-select">
      <div class="div-center">
        <div style="width:10vw">审核规则名称：</div>
          <el-input clearable @clear="query()" maxlength="15"  v-model="queryName"></el-input>
      </div>
      <el-button size="medium" @click="getDataList(queryName)" style="margin-left: 15px">查询</el-button>
      <el-button size="medium" @click="addRule" style="color:#4383dd">添加规则</el-button>
    </div>

    <main>
      <el-table :data="listData" height="calc(100vh - 200px)" style="width: 100%">
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="name" label="规则名称" align="center">
        </el-table-column>
        <el-table-column prop="apiName" label="操作名称" align="center">
        </el-table-column>
        <el-table-column prop="roleName" label="审核角色" align="center">
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              plain
              size="mini"
              @click="editItem(scope.row)"
            >修改</el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              plain
              size="mini"
              @click="deleteItem(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>

    <el-dialog
      :visible.sync="dialogVisible"
      :title="this.titleName"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="80px">
        <div >
          <el-form-item label="规则名称">
            <el-input maxlength="15" style="width: 100%" v-model="formInput.name"></el-input>
          </el-form-item>
          
        </div>
        <div>  
          <el-form-item label="执行操作">
            <el-select
              v-model="formInput.apiID"
              placeholder="请选择"
              clearable
              style="width: 100%"
              filterable
            >
              <el-option v-for="api in apiList" :key="api.id" :label="api.name" :value="api.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div >
          <el-form-item label="审核角色">
            <el-select
              v-model="formInput.roleID"
              placeholder="请选择"
              clearable
              style="width: 100%"
              filterable
            >
              <el-option v-for="role in roleList" :key="role.id" :label="role.name" :value="role.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitSave"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div> 
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import FileUpload from "./FileUpload";
import { Decimal } from "decimal.js";

import mixins from "../../minix";
let _vue;

export default {
  mixins: [mixins],
  name: "home",
  components: { FileUpload },

  data() {
    return {
      pageIdx: 0,
      itemTotal: 0,
      dialogVisible: false,
      listData: [],
      state: "",
      titleName:"",
      methodName:"",
      queryName:"",
      apiList:[],
      roleList:[],
      formInput: {
        name: "",
        apiID: "",
        apiName: "",
        roleID: "",
        roleName: ""
      },

      dialogUploadVisible: false,
      dialogUploadFile: "",


      dialogBillsVisible: false,

      pricings: []
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.query(0);

    _vue = this;
  },

  watch: {
    state() {
      this.initQuery();
    },
  },

  methods: {
    handleCurrentChange(val) {
      // eslint-disable-next-line no-console 
      this.pageIdx = val;
      this.query(val - 1);
    },

    handleSizeChange(val) {
      // eslint-disable-next-line no-console 
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    async showBillsDialog() {
      this.dialogBillsVisible = true;
      this.getBillsList();
    },

    editPrice(data) {
      let list = [];
      if (Array.isArray(data)) {
        data.forEach(item => {
          list.push({
            name: item.house,
            pricings: [
              {
                name: item.name,
                price: new Decimal(item.price).mul(new Decimal(10000)).toNumber()
              }
            ]
          });
        });
      } else {
        list.push({
          name: data.house,
          pricings: [
            {
              name: data.name,
              price: new Decimal(data.price).mul(new Decimal(10000)).toNumber()
            }
          ]
        });
      }

        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      axios({
        method: "post",
        url: "meters/pricings/edit",
        data: {
          data: list
        }
      })
        .then(value => {
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$message.success(message);
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(()=>{
          loading.close();
        });
    },

    getBillsList() {
      
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      axios({
        method: "post",
        url: "meters/pricings/query"
      }).then(value => {
        this.pricings = [];
        value.data.data.forEach(item => {
          item.pricings.forEach(data => {
            let price;

            if (data.name === "水费") {
              price = new Decimal(data.price)
                .div(new Decimal(10000))
                .toNumber()
                .toFixed(2);
            } else {
              price = new Decimal(data.price)
                .div(new Decimal(10000))
                .toNumber()
                .toFixed(4);
            }

            this.pricings.push({
              house: item.name,
              name: data.name,
              price: price
            });
          });
        });
      })
      .finally(()=>{
        loading.close();
      });
    },

    editItem(item) {
      this.formInput = {
        id: item.ID,
        name: item.name,
        apiID: item.apiID,
        apiName: item.apiName,
        roleID: item.roleID,
        roleName: item.roleName
      };
      this.queryPaiAndRole()
      this.titleName="编辑审核规则"
      this.methodName="edit"
      this.dialogVisible = true;
    },

    deleteItem(item) {
      let _vue = this;
      this.$confirm(
        `是否执行删除【${item.name}】操作？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
        axios({
          method: "post",
          url: "reviewrules/delete",
          data: {
            id: item.ID
          }
        })
          .then(value => {
            if (value.data.code === 0) {
            _vue.$message.success(value.data.message);
          } else{
            _vue.$message.error(value.data.message);
          }
          })
          .finally(() => {
            loading.close();
            _vue.query(_vue.pageIdx - 1);
          });
      });
    },
    queryPaiAndRole(){
      
      let roleData = {
              orgID: this.$route.query.orgID,
              pageSize: 100,
              pageIdx: 0
            };
            
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      axios({
        method: "post",
        url: "roles/query",
        data: roleData
      })
      .then(value => {
        this.roleList = [];
        if (value && value.data && value.data.data) {
          this.roleList= value.data.data
        }
      })
      .catch(() => {})
      
      let apiData = {
              orgID: this.$route.query.orgID
            };
      axios({
        method: "post",
        url: "apis/query",
        data: apiData
      })
      .then(value => {
        this.apiList = [];
        if (value && value.data && value.data.data) {
          this.apiList= value.data.data
        }
      })
      .catch(() => {})
      .finally(()=>{
        loading.close();
      })
        

    },
    addRule() {
      this.formInput = {
        name: "",
        apiID: "",
        apiName: "",
        roleID: "",
        roleName: ""
      };
      this.queryPaiAndRole()
      this.titleName="添加审核规则"
      this.methodName="add"
      this.dialogVisible = true;
    },

    submitSave() { 
      if (this.formInput.name.length <= 0) {
        this.$message.error("请输入规则名称");
        return;
      }
      if (this.formInput.apiID.length <= 0) {
        this.$message.error("请选择要执行操作");
        return;
      }
      if (this.formInput.roleID.length <= 0) {
        this.$message.error("请选择审核角色");
        return;
      }
      let data = { ...this.formInput };
      
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
      axios({
        method: "post",
        url: "reviewrules/"+this.methodName,
        data: data
      })
        .then(value => {
          if (value.data.code === 0) {
            this.$message.success(value.data.message);
            this.dialogVisible = false;
            this.pageIdx = 0;
            this.query(0);
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        });
    },

    uploadClose(done) {
      this.pageIdx = 0;
      this.query(0);
      done();
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(0);
    },

    //条件搜索
    getDataList(res){
      this.queryName=res
      this.query()
    },
    //列表查询
    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        pageSize: this.pageSize,
        pageIdx: pageIdx,
        name: this.queryName
      };
      const loading = Loading.service({
        lock: true,
        text: "正在加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: "reviewrules",
        data: data
      })
        .then(value => {
          this.listData = [];
          
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
              item.createdTime = Utils.long2second(item.createdTime * 1000);
              item.updatedTime = Utils.long2second(item.updatedTime * 1000);
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-input-group__prepend {
  width: 140px !important;
}
.el-input-group--prepend {
  margin-bottom: 10px;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.header-title {
  width: 150px;
}
</style>
